import request from "@/utils/request";

// 在线用户

// 查询用户组
export const getUserGroup = params => {
	return request({
		url: "/usergroup",
		method: "GET",
		params,
	});
};
